interface ParsedWeight {
  value: number;
  unit: string;
}

export const parseWeightString = (weightString: string): ParsedWeight => {
  const match = weightString.match(/^(\d+(?:\.\d+)?)\s*(kg|lbs)$/);
  if (!match) {
    throw new Error("Invalid weight format. Expected format: 75kg or 165.5lbs");
  }
  const [_, numericValue, unit] = match;
  return {
    value: Number(numericValue),
    unit: unit,
  };
};

export const formatWeight = (value: number, unit: string): string => {
  return `${value} ${unit}`;
};
